<section class="settings-panel" [class.mobile]="isMobile">
  <div class="head">
    <span class="material-icons go-back" (click)="goBack.emit()"> arrow_back </span>
    <div class="description">
      <div class="title">{{ panelData.name }}</div>
      <div class="subtitle">{{ panelData.description }}</div>
    </div>
    <span class="material-icons close" (click)="goBack.emit()"> close </span>
  </div>
  <div class="panel-body">
    <mat-tab-group color="primary" [disableRipple]="true" [(selectedIndex)]="selectedTabIndex">
      <mat-tab [label]="'Current Plan' | translate">
        <app-plan-and-usage (viewPlans)="goToAllPlans()"></app-plan-and-usage>
      </mat-tab>
      <mat-tab
        *ngIf="isAutomaticBillingWithVisiblePlans$ | async"
        [label]="'All Plans' | translate"
      >
        <app-user-settings-payment></app-user-settings-payment>
      </mat-tab>
      <mat-tab [label]="'Past Usage' | translate" *ngIf="(isSeatBased$ | async) === false">
        <app-billing-analytics-and-invoices></app-billing-analytics-and-invoices>
      </mat-tab>
    </mat-tab-group>
  </div>
</section>
